import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import ProblemSection from '../components/ProblemSection';
import FeaturesSection from '../components/FeaturesSection';
import AudienceSection from '../components/AudienceSection';
import MobileAppSection from '../components/MobileAppSection';
import TrustSection from '../components/TrustSection';
import TestimonialsSection from '../components/TestimonialsSection';
import HowItWorksSection from '../components/HowItWorksSection';
import FAQSection from '../components/FAQSection';
import FinalCTA from '../components/FinalCTA';

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [location.hash, location.key]);

  return (
    <>
      <HeroSection />
      <ProblemSection />
      <FeaturesSection />
      <AudienceSection />
      <MobileAppSection />
      <TrustSection />
      <TestimonialsSection />
      <HowItWorksSection />
      <FAQSection />
      <FinalCTA />
    </>
  );
}
